<template>
  <div>
    <div class="row mt-2">
      <div class="col-md-4">
        <div class="card">
          <div class="card-body p-0">
            <h5 class="card-title header-title border-bottom p-3 mb-0">MY EARNINGS</h5>
            <div class="text-muted text-center p-4" v-if="amount.length == 0">
              No available transaction(s).
            </div>
            <div
              v-for="(item, idx) in amount"
              :key="idx"
              class="media p-3"
              :class="item.class"
            >
              <div class="media-body">
                <h4 class="mt-0 mb-1 font-size-22 font-weight-normal">{{
                  item.amount_earned | currency(item.symbol, item.symbol == '¥' ? 0 : 2)
                }}</h4>
                <span class="text-muted">{{ item.code }}</span>
              </div>
              <feather
                type="circle"
                class="icon-dual icon-lg align-self-center"
              ></feather>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-8">
        <Table />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Table from './table'

export default {
  components: { Table },
  data(){
    return {
      amount:{}
    }
  },
	methods:{
    ...mapActions('finance', ['myEarning']),
  },
  beforeMount(){
    this.myEarning().then(res => {
      this.amount = res.data
    })
  }
}
</script>